.wrapperHorizontalScroll {
    display: block;
    overflow: auto hidden;
    scroll-snap-type: x mandatory;
}

.ulHorizontalScroll {
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
}

.liHorizontalScroll {
    display: inline-block;
    scroll-snap-align: start;
    white-space: normal;
}

.controls {
    display: flex;
    z-index: 1;
    gap: var(--spacer-8);
}

.navArrow {
    svg {
        display: block;
        width: var(--spacer-40);
        height: var(--spacer-40);
        fill: var(--color-contrast);
    }

    &.previous svg {
        transform: scaleX(-1);
    }
}
